import { useState, useCallback } from 'react';

function getRandomArbitrary(min, max) {
  return Math.random() * (max - min) + min;
}

export default function CatchMeChildren({ children }) {
  const [x, setX] = useState(50);
  const [y, setY] = useState(50);

  const newPosition = useCallback(() => {
    const deltaX = x + getRandomArbitrary(10, 30);
    const newX = deltaX > 100 ? getRandomArbitrary(5, 10) : deltaX;
    const newY = getRandomArbitrary(-10, 100);
    setX(newX);
    setY(newY);
  }, [x]);

  return (
    <div className="flex h-full w-full">
      <div
        className="relative drop-shadow-none p-4"
        style={{
          top: `${y}%`,
          left: `${x}%`,
          transition: 'left 320ms, top 320ms',
          transitionDelay: '16ms',
          marginLeft: '-180px',
          marginTop: '-150px',
        }}
        onMouseEnter={newPosition}
        onMouseOver={newPosition}
      >
        {children}
      </div>
    </div>
  );
}
